// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23c45500%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TalentDiscoveryHub_section__dQZ2- {
  max-width: 1200px;
  margin: 0 auto 3rem;
  padding: 0 1.25rem;
}

.TalentDiscoveryHub_card__ygQZY {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2.25rem;
  flex-wrap: wrap;
  overflow: visible;
  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 42%, #fffaf5 100%);
  border: 1px solid #fed7aa;
  border-radius: 18px;
  padding: 2rem 2.15rem;
  box-shadow:
    0 10px 32px rgba(255, 92, 9, 0.1),
    0 2px 8px rgba(10, 10, 10, 0.04);
  transition: box-shadow 0.25s ease, transform 0.2s ease;
}

.TalentDiscoveryHub_card__ygQZY:hover {
  box-shadow:
    0 14px 36px rgba(255, 92, 9, 0.14),
    0 4px 12px rgba(10, 10, 10, 0.05);
}

.TalentDiscoveryHub_card__ygQZY:focus-within {
  border-color: #ff5c09;
  box-shadow:
    0 14px 36px rgba(255, 92, 9, 0.16),
    0 0 0 3px rgba(255, 92, 9, 0.08);
}

.TalentDiscoveryHub_glow__HXeqO {
  position: absolute;
  top: -40%;
  right: -8%;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 92, 9, 0.12) 0%, transparent 70%);
  pointer-events: none;
}

.TalentDiscoveryHub_headerBlock__GjmUJ {
  flex: 1 1 280px;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.TalentDiscoveryHub_eyebrow__eFQoF {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-bottom: 0.65rem;
  padding: 0.28rem 0.65rem;
  border-radius: 999px;
  background: rgba(255, 92, 9, 0.1);
  border: 1px solid rgba(255, 92, 9, 0.18);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #c45500;
}

.TalentDiscoveryHub_title__fbl6S {
  margin: 0;
  font-size: clamp(1.25rem, 2.4vw, 1.65rem);
  font-weight: 800;
  line-height: 1.25;
  color: #0a0a0a;
  letter-spacing: -0.02em;
}

.TalentDiscoveryHub_console__wHfne {
  flex: 1.5 1 560px;
  display: grid;
  grid-template-columns: minmax(140px, 1fr) minmax(140px, 1fr) auto;
  gap: 0.9rem;
  align-items: end;
  position: relative;
  z-index: 2;
}

.TalentDiscoveryHub_field__Xw-R7 {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
}

.TalentDiscoveryHub_fieldLabel__gAyev {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b4f3a;
}

.TalentDiscoveryHub_selectWrap__jUISt {
  position: relative;
}

.TalentDiscoveryHub_selectWrap__jUISt::after {
  content: "";
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  pointer-events: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
}

.TalentDiscoveryHub_select__ZQUb2,
.TalentDiscoveryHub_input__lGWTS {
  width: 100%;
  border: 1px solid #f0d4bc;
  border-radius: 10px;
  padding: 0.72rem 0.9rem;
  font-size: 0.92rem;
  color: #0a0a0a;
  background: rgba(255, 255, 255, 0.92);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.TalentDiscoveryHub_select__ZQUb2 {
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  padding-right: 2.25rem;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.92);
  background-image: none;
}

.TalentDiscoveryHub_select__ZQUb2:focus,
.TalentDiscoveryHub_input__lGWTS:focus {
  outline: none;
  border-color: #ff5c09;
  box-shadow: 0 0 0 3px rgba(255, 92, 9, 0.12);
}

.TalentDiscoveryHub_locationWrap__MQ\\+ad {
  position: relative;
}

.TalentDiscoveryHub_locationIcon__EBtCG {
  position: absolute;
  left: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  color: #ff5c09;
  pointer-events: none;
  z-index: 3;
}

.TalentDiscoveryHub_locationWrap__MQ\\+ad .TalentDiscoveryHub_input__lGWTS {
  padding-left: 2.35rem;
}

.TalentDiscoveryHub_searchBtn__Ue9wi {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #ff682e 0%, #ff5c09 100%);
  color: #ffffff;
  font-size: 0.92rem;
  font-weight: 700;
  padding: 0.78rem 1.25rem;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(255, 92, 9, 0.28);
  transition: background 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
}

.TalentDiscoveryHub_searchBtn__Ue9wi:hover {
  background: linear-gradient(135deg, #ff5c09 0%, #e54f08 100%);
  transform: translateY(-1px);
  box-shadow: 0 8px 22px rgba(255, 92, 9, 0.34);
}

.TalentDiscoveryHub_error__95sR4 {
  width: 100%;
  margin: 0.75rem 0 0;
  font-size: 0.82rem;
  color: #c2410c;
  position: relative;
  z-index: 1;
}

@media (max-width: 991px) {
  .TalentDiscoveryHub_card__ygQZY {
    flex-direction: column;
    align-items: stretch;
    gap: 1.35rem;
    padding: 1.65rem;
  }

  .TalentDiscoveryHub_headerBlock__GjmUJ {
    flex: 0 0 auto;
  }

  .TalentDiscoveryHub_console__wHfne {
    flex: 0 0 auto;
    width: 100%;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      "intent role"
      "search search";
  }

  .TalentDiscoveryHub_searchBtn__Ue9wi {
    grid-column: 1 / -1;
    width: 100%;
  }
}

@media (max-width: 640px) {
  .TalentDiscoveryHub_section__dQZ2- {
    margin-bottom: 2rem;
  }

  .TalentDiscoveryHub_card__ygQZY {
    padding: 1.25rem;
    gap: 1rem;
    border-radius: 14px;
  }

  .TalentDiscoveryHub_title__fbl6S {
    font-size: 1.2rem;
  }

  .TalentDiscoveryHub_console__wHfne {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/TalentDiscoveryHub.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0EAA0E;EAC1E,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB;;oCAEkC;EAClC,sDAAsD;AACxD;;AAEA;EACE;;qCAEmC;AACrC;;AAEA;EACE,qBAAqB;EACrB;;oCAEkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,+EAA+E;EAC/E,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;EACpB,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,iEAAiE;EACjE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yDAAwQ;EACxQ,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,wDAAwD;AAC1D;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;EACf,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,4EAA4E;AAC9E;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,8BAA8B;IAC9B;;qBAEiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;AACF","sourcesContent":[".section {\n  max-width: 1200px;\n  margin: 0 auto 3rem;\n  padding: 0 1.25rem;\n}\n\n.card {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 2.25rem;\n  flex-wrap: wrap;\n  overflow: visible;\n  background: linear-gradient(135deg, #fff7ed 0%, #ffffff 42%, #fffaf5 100%);\n  border: 1px solid #fed7aa;\n  border-radius: 18px;\n  padding: 2rem 2.15rem;\n  box-shadow:\n    0 10px 32px rgba(255, 92, 9, 0.1),\n    0 2px 8px rgba(10, 10, 10, 0.04);\n  transition: box-shadow 0.25s ease, transform 0.2s ease;\n}\n\n.card:hover {\n  box-shadow:\n    0 14px 36px rgba(255, 92, 9, 0.14),\n    0 4px 12px rgba(10, 10, 10, 0.05);\n}\n\n.card:focus-within {\n  border-color: #ff5c09;\n  box-shadow:\n    0 14px 36px rgba(255, 92, 9, 0.16),\n    0 0 0 3px rgba(255, 92, 9, 0.08);\n}\n\n.glow {\n  position: absolute;\n  top: -40%;\n  right: -8%;\n  width: 280px;\n  height: 280px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 92, 9, 0.12) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.headerBlock {\n  flex: 1 1 280px;\n  min-width: 0;\n  position: relative;\n  z-index: 1;\n}\n\n.eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin-bottom: 0.65rem;\n  padding: 0.28rem 0.65rem;\n  border-radius: 999px;\n  background: rgba(255, 92, 9, 0.1);\n  border: 1px solid rgba(255, 92, 9, 0.18);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #c45500;\n}\n\n.title {\n  margin: 0;\n  font-size: clamp(1.25rem, 2.4vw, 1.65rem);\n  font-weight: 800;\n  line-height: 1.25;\n  color: #0a0a0a;\n  letter-spacing: -0.02em;\n}\n\n.console {\n  flex: 1.5 1 560px;\n  display: grid;\n  grid-template-columns: minmax(140px, 1fr) minmax(140px, 1fr) auto;\n  gap: 0.9rem;\n  align-items: end;\n  position: relative;\n  z-index: 2;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  min-width: 0;\n}\n\n.fieldLabel {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #6b4f3a;\n}\n\n.selectWrap {\n  position: relative;\n}\n\n.selectWrap::after {\n  content: \"\";\n  position: absolute;\n  right: 0.75rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  pointer-events: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23c45500' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.select,\n.input {\n  width: 100%;\n  border: 1px solid #f0d4bc;\n  border-radius: 10px;\n  padding: 0.72rem 0.9rem;\n  font-size: 0.92rem;\n  color: #0a0a0a;\n  background: rgba(255, 255, 255, 0.92);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.select {\n  appearance: none !important;\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n  padding-right: 2.25rem;\n  cursor: pointer;\n  background-color: rgba(255, 255, 255, 0.92);\n  background-image: none;\n}\n\n.select:focus,\n.input:focus {\n  outline: none;\n  border-color: #ff5c09;\n  box-shadow: 0 0 0 3px rgba(255, 92, 9, 0.12);\n}\n\n.locationWrap {\n  position: relative;\n}\n\n.locationIcon {\n  position: absolute;\n  left: 0.85rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #ff5c09;\n  pointer-events: none;\n  z-index: 3;\n}\n\n.locationWrap .input {\n  padding-left: 2.35rem;\n}\n\n.searchBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  border: none;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #ff682e 0%, #ff5c09 100%);\n  color: #ffffff;\n  font-size: 0.92rem;\n  font-weight: 700;\n  padding: 0.78rem 1.25rem;\n  white-space: nowrap;\n  cursor: pointer;\n  box-shadow: 0 6px 18px rgba(255, 92, 9, 0.28);\n  transition: background 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;\n}\n\n.searchBtn:hover {\n  background: linear-gradient(135deg, #ff5c09 0%, #e54f08 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 8px 22px rgba(255, 92, 9, 0.34);\n}\n\n.error {\n  width: 100%;\n  margin: 0.75rem 0 0;\n  font-size: 0.82rem;\n  color: #c2410c;\n  position: relative;\n  z-index: 1;\n}\n\n@media (max-width: 991px) {\n  .card {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1.35rem;\n    padding: 1.65rem;\n  }\n\n  .headerBlock {\n    flex: 0 0 auto;\n  }\n\n  .console {\n    flex: 0 0 auto;\n    width: 100%;\n    grid-template-columns: 1fr 1fr;\n    grid-template-areas:\n      \"intent role\"\n      \"search search\";\n  }\n\n  .searchBtn {\n    grid-column: 1 / -1;\n    width: 100%;\n  }\n}\n\n@media (max-width: 640px) {\n  .section {\n    margin-bottom: 2rem;\n  }\n\n  .card {\n    padding: 1.25rem;\n    gap: 1rem;\n    border-radius: 14px;\n  }\n\n  .title {\n    font-size: 1.2rem;\n  }\n\n  .console {\n    grid-template-columns: 1fr;\n    gap: 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `TalentDiscoveryHub_section__dQZ2-`,
	"card": `TalentDiscoveryHub_card__ygQZY`,
	"glow": `TalentDiscoveryHub_glow__HXeqO`,
	"headerBlock": `TalentDiscoveryHub_headerBlock__GjmUJ`,
	"eyebrow": `TalentDiscoveryHub_eyebrow__eFQoF`,
	"title": `TalentDiscoveryHub_title__fbl6S`,
	"console": `TalentDiscoveryHub_console__wHfne`,
	"field": `TalentDiscoveryHub_field__Xw-R7`,
	"fieldLabel": `TalentDiscoveryHub_fieldLabel__gAyev`,
	"selectWrap": `TalentDiscoveryHub_selectWrap__jUISt`,
	"select": `TalentDiscoveryHub_select__ZQUb2`,
	"input": `TalentDiscoveryHub_input__lGWTS`,
	"locationWrap": `TalentDiscoveryHub_locationWrap__MQ+ad`,
	"locationIcon": `TalentDiscoveryHub_locationIcon__EBtCG`,
	"searchBtn": `TalentDiscoveryHub_searchBtn__Ue9wi`,
	"error": `TalentDiscoveryHub_error__95sR4`
};
export default ___CSS_LOADER_EXPORT___;
